// TODO: get rid of this file in favour of export map in package.json
export * from "@design-system/shadcn";
export { Icon } from "@design-system/icons";
export type {
  IconProps,
  IconName,
  IconSize,
  CustomIconName,
} from "@design-system/icons";
export * as pagination from "@design-system/pagination";
export {
  FilterBar,
  FiltersProvider,
  isFilterValueSet,
  useFilters,
} from "@design-system/filters";
export type {
  FilterBarProps,
  FilterBarClearProps,
  FilterBarMenuProps,
  FilterBarMultiSelectProps,
  FilterBarSearchProps,
  FilterBarSelectProps,
  FilterDefinition,
  FiltersProviderProps,
  FilterValue,
  FilterValues,
} from "@design-system/filters";
export {
  DataTableProvider,
  DataTable,
  DataTableSortableHeader,
  DataTableSkeleton,
  DataTableLoadingOverlay,
  DataTableSheet,
  DataTableAnnouncer,
  DataTableColumnSelect,
  DataTableRowActions,
  useDataTableContext,
  useDataTablePaginationProps,
  useDataTableRowDetails,
} from "@design-system/data-table";
export type {
  ColumnDef,
  ColumnOrderState,
  ColumnVisibilityState,
  DataTableProviderProps,
  DataTableSheetProps,
  DataTableAnnouncerProps,
  DataTableColumnSelectProps,
  DataTableSearch,
  DataTableRowAction,
  DataTableRowActionsProps,
  RowSelectionState,
  SortOrder,
  UseDataTableRowDetailsOptions,
  UseDataTableRowDetailsResult,
} from "@design-system/data-table";
export {
  dataTableFeatures,
  SortOrderSchema,
  toReactTablePagination,
} from "@design-system/data-table";
